"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextInputContainer = void 0;
const styled_components_1 = require("styled-components");
exports.StyledTextInputContainer = styled_components_1.styled.div `
  display: flex;
  flex-wrap: wrap; /* Allows wrapping to new rows */

  /* Default: All items take full width on small screens */
  & > * {
    flex: 1 1 100%;
  }

  /* Apply specific styles for screens wider than 600px */
  @media (min-width: 600px) {
    & > * {
      flex: 1 1 calc(50% - 13px); /* Adjust for margin: 50% width minus half the gap for the first two elements */
    }

    & > *:nth-child(odd) {
      margin-right: 24px; /* Adds a 24px gap between the first and second items */
    }
    & > *:last-child {
      margin-right: 0px; /* Removes the gap from the last item */
    }
  }
`;
